module.exports = __webpack_public_path__ + "static/img/gxg_07.ff5b2c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxg_img/gxg_07.png
// module id = MENr
// module chunks = 46